import { render, staticRenderFns } from "./CreditClassNotification.vue?vue&type=template&id=6200bf64"
import script from "./CreditClassNotification.vue?vue&type=script&lang=js"
export * from "./CreditClassNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports